<template>
  <div class="cars-section text-center mt-6">
    <div class="vehicles mx-auto">
      <VehicleCard
        class="mb-8"
        v-for="vehicle of vehicles"
        :key="vehicle.id"
        :vehicle="vehicle"
        :showActions="true"
        :showCarousel="true"
      />
    </div>
  </div>
</template>

<script>
import {VehicleCard} from  '@/components'
import vehicles from '@/api/vehicles.json'

export default {
  name: 'all-cars',
  components: {
    VehicleCard
  },
  data: () => ({
    vehicles: [...vehicles]
  })
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 320px) {
  .all-cars {
    margin-top: 20px !important;
    font-size: 20px !important;
  }
}
.cars-section {
  .vehicles {
    width: 95%;
  }
}
</style>